var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256.188,
    height: 199,
    viewBox: "0 0 256.188 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_65509",
    x: 0,
    y: 11.781,
    width: 66.5,
    height: 53.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65510",
    x: 189.688,
    y: 55.759,
    width: 66.5,
    height: 53.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65504",
    x: 125.755,
    y: 96.046,
    width: 32.439,
    height: 35.539,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65505",
    x: 110.232,
    y: 95.733,
    width: 31.8,
    height: 36.06,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65506",
    x: 94.305,
    y: 96.046,
    width: 32.44,
    height: 35.54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53055",
    "data-name": "Group 53055",
    transform: "translate(-557.75 -241.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53052",
    "data-name": "Group 53052",
    transform: "translate(0 -3.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53044",
    "data-name": "Group 53044",
    transform: "translate(0 -39.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53032",
    "data-name": "Group 53032",
    transform: "translate(10 -54.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52924",
    "data-name": "Group 52924",
    transform: "translate(459 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52922",
    "data-name": "Group 52922",
    transform: "translate(-33 -90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51884",
    "data-name": "Group 51884",
    transform: "translate(131 454.301)",
    opacity: 0.228
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51882",
    "data-name": "Group 51882"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(19 16.699)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(0 -0.301)",
    fill: "#039"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51883",
    "data-name": "Group 51883",
    transform: "translate(195 58.699)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211-2",
    "data-name": "Ellipse 211",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(19 0)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212-2",
    "data-name": "Ellipse 212",
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5,
    transform: "translate(0 29)",
    fill: "#039"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52921",
    "data-name": "Group 52921",
    transform: "translate(149.083 439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 99.5,
    cy: 99.5,
    r: 99.5,
    transform: "translate(-0.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.33, 0)",
    filter: "url(#Path_65509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65509-2",
    "data-name": "Path 65509",
    d: "M48,25.6a9.6,9.6,0,0,1-9.6,9.6H11.2a10.787,10.787,0,0,1-7.912-3.288A10.787,10.787,0,0,1,0,24a10.869,10.869,0,0,1,1.775-6.038A11.025,11.025,0,0,1,6.45,13.875q-.05-.7-.05-1.075a12.332,12.332,0,0,1,3.75-9.05A12.332,12.332,0,0,1,19.2,0a12.391,12.391,0,0,1,7.163,2.2A12.784,12.784,0,0,1,31.05,7.95,6.052,6.052,0,0,1,35.2,6.4a6.166,6.166,0,0,1,4.525,1.875A6.166,6.166,0,0,1,41.6,12.8a6.2,6.2,0,0,1-1.025,3.45A9.388,9.388,0,0,1,45.9,19.613,9.29,9.29,0,0,1,48,25.6Z",
    transform: "translate(9.25 18.03)",
    fill: "#fff",
    stroke: "#b7cfff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.33, 0)",
    filter: "url(#Path_65510)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65510-2",
    "data-name": "Path 65510",
    d: "M48,25.6a9.6,9.6,0,0,1-9.6,9.6H11.2a10.787,10.787,0,0,1-7.912-3.288A10.787,10.787,0,0,1,0,24a10.869,10.869,0,0,1,1.775-6.038A11.025,11.025,0,0,1,6.45,13.875q-.05-.7-.05-1.075a12.332,12.332,0,0,1,3.75-9.05A12.332,12.332,0,0,1,19.2,0a12.391,12.391,0,0,1,7.163,2.2A12.784,12.784,0,0,1,31.05,7.95,6.052,6.052,0,0,1,35.2,6.4a6.166,6.166,0,0,1,4.525,1.875A6.166,6.166,0,0,1,41.6,12.8a6.2,6.2,0,0,1-1.025,3.45A9.388,9.388,0,0,1,45.9,19.613,9.29,9.29,0,0,1,48,25.6Z",
    transform: "translate(198.94 62.01)",
    fill: "#fff",
    stroke: "#9fbfff",
    strokeWidth: 0.5
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53047",
    "data-name": "Group 53047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53046",
    "data-name": "Group 53046",
    transform: "translate(-13.75 -14.131)",
    opacity: 0.403
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(647.5 310.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3450",
    "data-name": "Rectangle 3450",
    width: 100.5,
    height: 100.5,
    transform: "translate(0)",
    fill: "#039",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "ferry",
    d: "M20.338,23.923H75.353V42.078L47.846,33.092,20.338,42.078M10.894,83.522h.275c7.335,0,13.754-4.034,18.338-9.169,4.585,5.135,11,9.169,18.338,9.169S61.6,79.488,66.184,74.353c4.585,5.135,11,9.169,18.338,9.169h.229l8.711-30.671a4.956,4.956,0,0,0-.275-3.53,4.7,4.7,0,0,0-2.751-2.292L84.522,45.1V23.923a9.167,9.167,0,0,0-9.169-9.169H61.6V1H34.092V14.754H20.338a9.169,9.169,0,0,0-9.169,9.169V45.1L5.255,47.029A4.7,4.7,0,0,0,2.5,49.321a4.956,4.956,0,0,0-.275,3.53m82.293,39.84a31.958,31.958,0,0,1-18.338-6.1,31.538,31.538,0,0,1-36.676,0,31.958,31.958,0,0,1-18.338,6.1H2v9.169h9.169a40.087,40.087,0,0,0,18.338-4.585,39.852,39.852,0,0,0,36.676,0,39.945,39.945,0,0,0,18.338,4.585h9.169V92.691Z",
    transform: "translate(2.585 -1)",
    fill: "#039"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ferry-2",
    "data-name": "ferry",
    d: "M84.522,69.27a31.958,31.958,0,0,1-18.338-6.1,31.538,31.538,0,0,1-36.676,0,31.958,31.958,0,0,1-18.338,6.1H2v9.169h9.169a40.087,40.087,0,0,0,18.338-4.585,39.852,39.852,0,0,0,36.676,0,39.945,39.945,0,0,0,18.338,4.585h9.169V69.27Z",
    transform: "translate(649.904 347.926)",
    fill: "#039",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.548
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65507",
    "data-name": "Path 65507",
    d: "M36.134,16.247a3,3,0,0,1,.218-3.6,5.976,5.976,0,0,0,.326-7.377L36.129,4.5H32.7l-.171.122,1.707,2.39a2.982,2.982,0,0,1-.163,3.681,6.009,6.009,0,0,0-.436,7.218l.559.839H37.8Z",
    transform: "translate(645.459 272.5)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65508",
    "data-name": "Path 65508",
    d: "M42.884,16.247a3,3,0,0,1,.217-3.6,5.976,5.976,0,0,0,.326-7.377L42.879,4.5H39.45l-.171.122,1.707,2.39a2.982,2.982,0,0,1-.163,3.681,6.009,6.009,0,0,0-.436,7.218l.559.839h3.606Z",
    transform: "translate(645.459 272.5)",
    fill: "#e2e2e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53054",
    "data-name": "Group 53054",
    transform: "translate(661.305 342.986)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -103.55, -101.98)",
    filter: "url(#Path_65504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65504-2",
    "data-name": "Path 65504",
    d: "M105.624,15.949V12.683l7.478-10.7h4.52v10.46h1.941v3.5h-1.941v3.077h-4.047V15.949Zm8.235-9.513-3.975,6.011h3.975Z",
    transform: "translate(29.38 100.31)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -103.55, -101.98)",
    filter: "url(#Path_65505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65505-2",
    "data-name": "Path 65505",
    d: "M55.065,2.343A5.669,5.669,0,0,1,60.141,0a5.672,5.672,0,0,1,5.077,2.343,11.389,11.389,0,0,1,1.573,6.413,11.487,11.487,0,0,1-1.573,6.461,5.672,5.672,0,0,1-5.077,2.343,5.669,5.669,0,0,1-5.077-2.343,11.47,11.47,0,0,1-1.574-6.461,11.372,11.372,0,0,1,1.574-6.413m7.23,2.733a2.443,2.443,0,0,0-4.306,0,10.181,10.181,0,0,0-.522,3.68,15.369,15.369,0,0,0,.191,2.663,3.39,3.39,0,0,0,.769,1.7,2.587,2.587,0,0,0,3.432,0,3.425,3.425,0,0,0,.769-1.7,15.425,15.425,0,0,0,.188-2.663,10.226,10.226,0,0,0-.52-3.68",
    transform: "translate(65.99 101.98)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -103.55, -101.98)",
    filter: "url(#Path_65506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65506-2",
    "data-name": "Path 65506",
    d: "M8.235,6.435v6.011H4.26Zm-.757-4.45L0,12.682v3.265H7.952v3.077H12V15.948H13.94v-3.5H12V1.985Z",
    transform: "translate(103.55 100.31)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.cfacab6e6ebe4710e66c9742c1ec5395.svg";
export { ForwardRef as ReactComponent };